import actions from './actions'

const initialState = {
  id : "",
  type: "",
  spend: {
    dollar_value_spent : "",
    earned_points : "",
    levels : []
  },
  visit: {
    no_of_visit : "",
    earned_points : "",
    levels : []
  },
  sign_up_bonus : {
    bonus_type : "",
    bonus_value : 0,
    reward_name : "",
    expire_in : ""
  },
  terms_and_conditions : "",
  loading: false
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
